const state = {
  showContactIndex: -1,
  contact: {}
}

const getters = {
  getShowContactIndex: (state) => {
    return state.showContactIndex
  },
  getContact: (state) => {
    return state.contact
  }
}

const mutations = {
  setShowContactIndex(state, index) {
    state.showContactIndex = index
  },
  setContact(state, data) {
    state.contact = data
  },
}
const actions = {
  async loadContact({ commit }, id) {
    try {
      commit('setContact', {})
      const res = await this.$api.documents.getContact(id)
      const data = res || {}
      commit('setContact', data)
    } catch (error) {
      commit('setContact', {})
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
